module.exports = __webpack_public_path__ + "img/30.4840fc75.png";